import type { CollapsibleWidgetResolved } from './types';
import { Collapsible } from '@/components/Collapsible';
import { RichText } from '@/lib/render/RichText';
import { Text } from '@/lib/render/Text';

export function CollapsibleWidgetComponent({
  resolved,
}: {
  resolved: CollapsibleWidgetResolved;
}) {
  const { title, body } = resolved;
  if (!title || !body) {
    return null;
  }
  return (
    <div className="pt-4">
      <Collapsible
        header={
          <Text field="title" className="text-primary font-semibold">
            {title}
          </Text>
        }
        className="w-full rounded-none bg-transparent px-0"
        centered
      >
        <RichText nodes={body} />
      </Collapsible>
    </div>
  );
}
